export enum BetStatus {
	ALL = "all",
	CLOSED = "closed",
	LIVE = "live",
	OPEN = "open",
}

export enum BetDetailedStatus {
	ALL = "all",
	CLOSED = "closed",
	OPEN = "open",
	CANCELLED = "cancelled",
	RETURNED = "returned",
	WON = "won",
	LOST = "lost",
}

export const nonStandardBetStatuses = new Set<string>([
	BetDetailedStatus.CANCELLED,
	BetDetailedStatus.RETURNED,
	BetDetailedStatus.WON,
	BetDetailedStatus.LOST,
]);
